<template>
    <div class="share">
        <h2 class="section-title">FOLLOW US</h2>
        <div class="sns">
        <a href="https://www.facebook.com/nutas.by.jda/" target="_blank">
            <img src="@/assets/icon-fb.svg" alt="fb-Share">
        </a>
        <a href="https://twitter.com/Nutas_byJDA" 
            target="_blank">
            <img src="@/assets/icon-tw.svg" alt="tw-share">
        </a>
        <a href="https://www.instagram.com/the_japan_dietetic_association/" target="_blank">
            <img src="@/assets/icon-insta.svg" alt="insta-share">
        </a>
        </div>
    </div>  
</template>

<script>
export default {
    name: 'share'
}
</script>

<style lang="scss" scoped>
    .share{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
        h2.section-title{
        font-size: 3.125em;
        margin-bottom: 54px;
        line-height: 1em;
        @media #{$maxM}{
            font-size: 3em;
            margin-bottom: 40px;
        }
        }
        .sns{
        display: flex;
        justify-content: center;
        align-items: stretch;
        flex-flow: row nowrap;
            a{
            width: 45px;
            height: 45px;
            margin-right: 43px;
            &:last-child{
                margin-right: 0;
            }
            @media #{$maxM}{
                width: 48px;
                height: 48px;
                margin-right: 45px;
            }
            }
        }
    }
</style>